module.exports = __webpack_public_path__ + "static/media/me-you-us.80687d47.png";